<h2 mat-dialog-title class="title">{{ data.title ?? "Information" }}</h2>
<mat-dialog-content>
  <p class="description">
    {{ data.message ?? "Your request will be processed as soon as possible." }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="go-back" type="button" mat-button>
    <mat-icon [svgIcon]="icons.ArrowLeftIcon"></mat-icon>CANCEL
  </button>
  <button class="approve" mat-button [mat-dialog-close]="true">
    <mat-icon [svgIcon]="icons.YesIcon"></mat-icon> CONFIRM
  </button>
</mat-dialog-actions>
